import Text from "common/Typography/Text";
import Modal from "common/Modal/Modal";
import { displayResultMessage } from "utils/misc";
import { formatDate } from "@shared/utils/date";
import { GroupData, LanguageNameSpaces } from "@shared/types";
import { sharedLib } from "@shared/services/shared.service";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface CancelGroupSubscriptionModalProps {
  groupData?: GroupData;
  closeModal: () => void;
  visible: boolean;
}

const CancelGroupSubscriptionModal = ({
  groupData,
  closeModal,
  visible,
}: CancelGroupSubscriptionModalProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BILLING);
  const [cancelSubscription, { isLoading: isLoadingCancelSubscription }] =
    sharedLib.sharedApi.settings.useCancelSubscriptionMutation();

  const onCancelSubscriptionClick = () => {
    if (groupData) {
      displayResultMessage(
        cancelSubscription({ sub_group_id: groupData.id }).unwrap(),
        t("cancel_group_subscription_modal.success_message"),
        t("cancel_group_subscription_modal.error_message"),
        undefined
      ).then(closeModal);
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={closeModal}
      title={t("cancel_group_subscription_modal.title")}
      destroyOnHidden={true}
      okText={t("cancel_group_subscription_modal.yes")}
      onOk={onCancelSubscriptionClick}
      okButtonProps={{ loading: isLoadingCancelSubscription }}
      cancelButtonProps={{ disabled: isLoadingCancelSubscription }}
    >
      <Text as="div">
        <div>{t("cancel_group_subscription_modal.scheduled_end_message")}</div>
        {groupData && (
          <div>{formatDate(groupData.expiration_timestamp, true, true)}</div>
        )}
        <div style={{ marginTop: 8 }}>
          {t("cancel_group_subscription_modal.after_end_prefix")}{" "}
          {groupData?.name || t("cancel_group_subscription_modal.the_group")}{" "}
          {t("cancel_group_subscription_modal.after_end_suffix")}
        </div>
        <div style={{ marginTop: 8 }}>
          {t("cancel_group_subscription_modal.confirm_message")}
        </div>
      </Text>
    </Modal>
  );
};

export default CancelGroupSubscriptionModal;
